export const TAB_SPACES = ' '.repeat(4);

/**
 * Default API endpoint prefix (e.g., "/api")
 * Used when apiEndpoints.apiEndpointPrefix is not configured
 */
export const DEFAULT_API_PREFIX = '/api';

/**
 * Default page data endpoint name (e.g., "page_data")
 * Used when apiEndpoints.pageDataEndpoint is not configured
 */
export const DEFAULT_PAGE_DATA_ENDPOINT = 'page_data';
